export enum ReportSubscriptionChannelEnum {
    Unknown = 0,
    Email = 1,
    SFTP = 2,
}

export function getReportSubscriptionChannelEnumLabel(t: ReportSubscriptionChannelEnum): string {
    var res = "common.unknown";

    if (t == ReportSubscriptionChannelEnum.Email) {
        res = "reportSubscription.email";
    }

    if (t == ReportSubscriptionChannelEnum.SFTP) {
        res = "reportSubscription.SFTP";
    }

    return res;
}
